module.exports = __webpack_public_path__ + "img/hot-dish.2c04008a.svg";